import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import SftpReaderForm from '../forms/sftp-reader-form';
import { sftpReaderValidationSchema } from '../schema/sftpReader.js';

export default function SftpReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'SFTP Reader Node Details',
        altText: 'SFTP Reader Node',
        defaultLabel: 'SFTP Reader Node',
      }}
    >
      <CommonNode FormComponent={SftpReaderForm} schemaResolver={sftpReaderValidationSchema} />
    </NodeProvider>
  );
}
